<template>
  <error-component />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { logEvent } from "@/common/logger";
import ErrorComponent from "@/components/error/Error.vue";

const componentName = "ErrorRoute";

export default defineComponent({
  name: componentName,
  components: { ErrorComponent },
  setup() {
    logEvent("Created", componentName);
  },
});
</script>
